module.exports = __webpack_public_path__ + "img/credit_card.b65935f6.svg";